import "layouts/Home/Home.css";
import _noImage from '../../../assets/img/Letflow/no-image.jpg'
import _noImage_16_9 from '../../../assets/img/Letflow/no-image-16-9.jpg'
import {request} from "../../../api-client";
import {TableButtonsBuilder} from "../../../components/Letflow/Table";
import {userCanMakeReservations} from "../../../api-client/core/authentication/utils";
import {noop} from "../../../utils";

export const emptyImage = _noImage

export const makeImageUrl = (element, size) => element.image ? request.file.image.makeCroppedUrl(element.image.id, size, size) : _noImage

export const makeImageUrlWithSize = (element, size, defaultValue = _noImage) => {
  if (element && element.image) {
    if (size === 'lg') {
      return request.file.image.makeCroppedUrl(element.image.id, 1280 , 720)
    }
    if (size === 'md') {
      return request.file.image.makeCroppedUrl(element.image.id, 400 , 400)
    }
    if (size === 'md-16:9') {
      return request.file.image.makeCroppedUrl(element.image.id, 400 , 225)
    }
    if (size === 'sm') {
      return request.file.image.makeCroppedUrl(element.image.id, 200, 200)
    }
    if (size === 'xs') {
      return request.file.image.makeCroppedUrl(element.image.id, 50, 50)
    }
    if (size === 'reel-lg') {
      return request.file.image.makeCroppedUrl(element.image.id, 1200 , 500)
    }
    if (size === 'reel-md') {
      return request.file.image.makeCroppedUrl(element.image.id, 600 , 240)
    }
    if (size === 'reel-sm') {
      return request.file.image.makeCroppedUrl(element.image.id, 180, 100)
    }

    if (size === 'category-md') {
      return request.file.image.makeCroppedUrl(element.image.id, 550, 300)
    }
  }  else {
    if (size === 'md-16:9') {
      return _noImage_16_9;
    }
    return defaultValue
  }
}

export const makeThumbnailUrlWithSize = (element, size) => {
  if (element.thumbnail) {
    if (size === 'lg') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 1280 , 720)
    }
    if (size === 'md') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 400 , 400)
    }
    if (size === 'md-16:9') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 400 , 225)
    }
    if (size === 'sm') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 200, 200)
    }
    if (size === 'xs') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 50, 50)
    }
    if (size === 'reel-lg') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 1200 , 500)
    }
    if (size === 'reel-md') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 600 , 240)
    }
    if (size === 'reel-sm') {
      return request.file.image.makeCroppedUrl(element.thumbnail.id, 180, 100)
    }
  }  else {
    if (size === 'md-16:9') {
      return _noImage_16_9;
    }
    return _noImage
  }
}

export const makeThumbnailUrl = (element, width, height) => element.thumbnail ? request.file.image.makeCroppedUrl(element.thumbnail.id, width, height) : _noImage

export const makeAlbumImageUrl = (album, size) => makeImageUrl(album, size)

export const makeSpeakerImageUrl = (speaker, size) => makeImageUrl(speaker, size)

export const makePlaylist = (element, tracksProperty, requestType, onClick = noop) => element[tracksProperty].map(track => ({
  fetchSrc: () => request[requestType].audioUrl(track.id),
  title: track.title,
  subtitle: element.title,
  image: makeImageUrlWithSize(element, 'xs'),
  onImageClick: () => onClick(element),
  onTitleClick: () => onClick(element),
  onSubtitleClick: () => onClick(element),
  type: requestType,
}))

export const makeAlbumPlaylist = (album, onClick) => makePlaylist(album, 'musics', 'music', onClick)

export const makeSpeakerPlaylist = (speaker, onClick) => makePlaylist(speaker, 'voices', 'voice', onClick)

export const makeActionButtons = (
  track,
  playlist,
  requestType,
  clientId,
  onAddToPlaylistClosed,
  history,
  match,
  showPlaylistButton = true
) => {

  const builder = new TableButtonsBuilder()

  const modelType = requestType + 's' // track type has to be plural

  builder.withDownload(() => request[requestType].download(track.id, {}), { title: track.title, duration: track.audio.duration, type: requestType })

  requestType === 'music' && userCanMakeReservations() && builder.withRequestReservation(track)

  showPlaylistButton && builder.withAddToPlaylist(clientId, track, modelType, onAddToPlaylistClosed, history, match)

  builder.withPlay({
    songs: playlist,
    playIndex: track.index,
  })

  return builder.build()
}